/**
 * Servicio que se encarga del manejo de las peticiones sobre las
 * transacciones de los equipos con los terceros
 * JMM-2018-05-17
 */
import { Injectable } from '@angular/core';
//Enrutamientos
import { Http, Response } from '@angular/http';
//Servicios
import { ConfigService } from '../../servicios/config/config.service';
//key
import { KeyService } from '../../servicios/key.service';

@Injectable()
export class EquipoTerceroService {

  public equipoTercero : any[] = [];
  PATH = new ConfigService().obtenerPath();

  constructor(
    private http  : Http,
    private _key  : KeyService
  ) {}

  ngOnInit(){}

  /**
   * Obtener todos los equipo terceros
   * JMM-2018-05-17
   */
  getEquipoTercero(){
    let url = this.PATH + '/api/public/equipoterceros';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getEquipoTercero()

  /**
   * Permite obtener el identificador del ultimo registro
   * JMM-2018-05-09
   */
  generaConsecutivoEquipoTercero(){
    let url = this.PATH + '/api/public/generaConsecutivoEquipotercero';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .generaConsecutivoEquipoTercero()

  /**
   * Enviar equipo tercero
   * JMM-2018-05-17
   */
  setEquipoTercero(equipotercero:any){
    let url = this.PATH + '/api/public/equipoterceros';
    return this.http.post(url, equipotercero, {headers:this._key.head()}).map(resp => resp.json());
  }// .setEquipoTercero(equipotercero:any)

  /**
   * Editar equipo tercero
   * JMM-2018-05-17
   */
  editEquipoTercero(equipotercero:any){
    let url = this.PATH+'/api/public/equipoterceros/'+equipotercero.id;
    return this.http.put(url, equipotercero, {headers:this._key.head()}).map( resp => resp.json());
  }// .editEquipoTercero(equipotercero:any)

  /**
   * Eliminar equipo tercero
   * JMM-2018-05-17
   */
  destroyEquipoTercero(id:any){
    let url = this.PATH + '/api/public/equipoterceros/'+id+'/destroy';
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }// .destroyEquipoTercero(id:any)

  /**
   * Obtener la información del registro para poder modificarlo
   * JMM-2018-05-21
   */
  obtenerequipoTerceroEditar(id:any){
    let url = this.PATH + '/api/public/equipoterceros/'+id+'/edit';
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json());
  }// .obtenerequipoTerceroEditar(id:any)

  /**
   * Obtiene la información del equipo para un tercero especifico
   * JMM-2018-06-18
   */
  listEquipoTercero(equipoterceroid:string){
    let url = this.PATH + '/api/public/list-equipostercero/' + equipoterceroid;
    return this.http.get(url, { headers: this._key.head()}).map( resp => resp.json());
  }

  /**
   * Obtiene la información del equipo para un tercero especifico
   * JMM-2018-07-05
   */
  listEquipoTerceroPorTercero(terceroid:string = null){
    terceroid = terceroid ? terceroid : null;
    let url = this.PATH + '/api/public/list-equipostercero-por-tercero/' + terceroid;
    return this.http.get(url, { headers: this._key.head()}).map( resp => resp.json());
  }

  /**
   * Obtiene la información del equipo para un tercero especifico
   * JMM-2018-07-05
   */
  listEquipoTerceroPorTerceroSucursal(sucursalid:string){
    let url = this.PATH + '/api/public/list-equipostercero-por-tercero-sucursal/' + sucursalid;
    return this.http.get(url, { headers: this._key.head()}).map( resp => resp.json());
  }

    /**
   * Obtiene la información del equipo para un tercero especifico
   * CESAER ARIAS-2019-05-03
   */
  listOperacionesItemequipo(itemequipoid:string){
    let url = this.PATH + '/api/public/listOperacionesItemequipo/' + itemequipoid;
    return this.http.get(url, { headers: this._key.head()}).map( resp => resp.json());
  }

  /**
   * Obtiene el listado de actividades por familia sugun el  itemequipo
   * CESAER ARIAS-2019-05-03
   */
  listActividadesItemequipo(itemequipoid:string){
    let url = this.PATH + '/api/public/listActividadesItemequipo/' + itemequipoid;
    return this.http.get(url, { headers: this._key.head()}).map( resp => resp.json());
  }

  /**
   * Función que permite retornar los datos del equipo dependiendo de la petición que se realice,
   * esto es, si llega el terceroid invoca la función listEquipoTercero
   * de lo contrario invoca la función getEquipoTercero
   * JMM-2018-06-18
   */
  listarEquiposTerceros(terceroid:string){
    if (terceroid) {
      let url = this.PATH + '/api/public/list-equipostercero/' + terceroid;
      return this.http.get(url, { headers: this._key.head()}).map( resp => resp.json());
    } else {
      let url = this.PATH + '/api/public/equipoterceros';
      return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
    }
  }// .listarEquiposTerceros(terceroid:string)

  /**
   * Obtener las sucursales que pertenecen aun tercero especifico
   * JMM-2018-09-03
   */
  getEquiposSucursal(terceroid, sucursalid){
      let url = this.PATH+'/api/public/list-equipossucursal/'+terceroid+'/'+sucursalid;
      return this.http.get(url, {headers:this._key.head()}).map(resp=>resp.json());
  }// .getEquiposSucursal(sucursalid)

  /**
   * Obtener el listado de equipos terceros segun filtro
   * JMM-2018-09-03
   */
  getEquiposTercerosFiltro(terceroid, sucursalid, equipoid , marcaid , familiaid,adquisicion,idperfil){
    terceroid   = terceroid   == undefined || terceroid   == '' ? null : terceroid;
    sucursalid  = sucursalid  == undefined || sucursalid  == '' ? null : sucursalid.sucursalid;
    equipoid    = equipoid    == undefined || equipoid    == '' ? null : equipoid.equipoid;
    marcaid     = marcaid     == undefined || marcaid     == '' ? null : marcaid.marcaid;
    familiaid   = familiaid   == undefined || familiaid   == '' ? null : familiaid.familiaid;
    adquisicion   = adquisicion   == undefined || adquisicion   == '' ? null : adquisicion.tipoadquisicionid;

    idperfil    = idperfil    == undefined || idperfil   == '' ?  null : idperfil;

    let url = this.PATH + '/api/public/list-equiposterceros/'+terceroid+'/'+sucursalid+'/'+equipoid+'/'+marcaid+'/'+familiaid+'/'+adquisicion+'/'+idperfil;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getEquiposTercerosFiltro(terceroid, sucursalid, equipoid)

  /**
   * Obtener el listado de sucursales
   * JMM-2018-09-05
   */
  getSucursalesFiltro(){
    let url = this.PATH + '/api/public/lista-sucursales';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getSucursalesFiltro()

  /**
   * Obtener el listado de equipos
   * JMM-2018-09-05
   */
  getEquiposFiltro(){
    let url = this.PATH + '/api/public/lista-equipos';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getEquiposFiltro()

  /**
   * Obtener equipo especifico
   * JMM-2018-09-07
   */
  getEquipoTerceroEspecifico(equipoid){
    let url = this.PATH + '/api/public/list-equipoterceroespecifico/'+equipoid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getEquipoTerceroEspecifico(equipoid)

  /**
   * Obtener equipo especifico
   * JMM-2018-09-07
   */
  terceroresponsable(itemequipoid){
    let url = this.PATH + '/api/public/terceroresponsable/'+itemequipoid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .terceroresponsable(equipoid)

      /**
   * valida si el registro a guardar conside con otro
   *  en la BD si es asi informa al cliente para evitar duplicados
   * CAAA-2018-10-10
   */

  validadorDeregistros(terceroid,sucursalid,equipoid,serial){
    terceroid   = terceroid   == undefined || terceroid   == '' ? null : terceroid;
    sucursalid  = sucursalid  == undefined || sucursalid  == '' ? null : sucursalid;
    equipoid    = equipoid    == undefined || equipoid    == '' ? null : equipoid;
    serial      = serial      == undefined || serial      == '' ? null : serial;

    let url = this.PATH +'/api/public/validadorDeregistros/'+terceroid+'/'+sucursalid+'/'+equipoid+'/'+serial;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  recargar(){
    return 1;
  }

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/equipos/equipo-tercero.service.ts